/*
 * @Author: Hugo
 * @Date: 2020-10-13 13:56:09
 * @LastEditTime: 2020-10-21 10:19:57
 * @LastEditors: Please set LastEditors
 * @Description: 树模型
 * @FilePath: /Workbench_Front_Support/src/workbench_front/common/models/TreeModel/index.js
 */
import Tree from '../Tree';
import Node from '../Node';
export default class TreeModel extends Tree {
    constructor(data) {
        super(data);
    }
    /**
     * 获取节点
     * @param {Function} checkFn
     * @param {Function} traversal
     */
    getNode(checkFn, traversal) {
        let ret = null;
        let callback = function(node) {
            if (checkFn(node)) {
                ret = node;
            }
        };
        if (!traversal) {
            traversal = this.traverseDF;
        }
        this.contains(callback, traversal);
        return ret;
    }
    /**
     * 在目标节点toData前插入节点
     * 假设待插入节点为A，目标节点B
     * 1. 先在树中检索A的位置
     * 2. 在树中检索B节点，并获取B的父节点和B在父节点中的索引index
     * 3. 如果A不在树中，
     *         创建节点A，
     *         执行数组合并，更新B.parent.children, B.parent.children = Array.concat(B.parent.children.slice(0, index), A, B.parent.children.slice(index)),
     *         设置节点A.parent = B.parent
     * 4. 如果A在树中， 获取A节点的父节点A.parent和A的索引index2
     * 5. 如果A.parent === B.parent,证明节点A在同级移动位置，
     *         判断A的index2 < B的index1？
     *         如果index2<index1, index1 = index1 - 1
     *         执行let temp = B.parent.children.splice(index2, 1)
     *         执行B.parent.children = Array.concat(B.parent.children.slice(0, index1), temp, B.parent.children.slice(index1))
     * 6. 如果A.parent !== B.parent,证明节点A与节点B不再同级,
     *         执行let temp = A.parent.children.splice(index2, 1)
     *         执行B.parent.children= Array.concat(B.parent.children.slice(0, index), temp, B.parent.children.slice(index))
     *         执行更新A节点的父节点引用，A.parent = B.prent
     *
     * @param {ComponentInstanceMeta} data
     * @param {ComponentInstanceMeta} toData
     * @param {Function} traversal
     * @returns    {Node} nodeA
     */
    before(data, toData, traversal) {
        let checkDataFn = function(node) {
            return node.data === data;
        };
        let checkToDataFn = function(node) {
            return node.data === toData;
        };
        if (!traversal) {
            traversal = this.traverseDF;
        }
        let nodeA = this.getNode(checkDataFn, traversal);
        let nodeB = this.getNode(checkToDataFn, traversal);
        let parentA = null;
        let parentB = null;
        let childrenA = null;
        let childrenB = null;
        let indexA = -1;
        let indexB = -1;
        let temp = null;
        if (nodeB === null) {
            throw new Error('Target Node is not in the tree');
        }
        parentB = nodeB.parent;
        childrenB = parentB.children;
        indexB = childrenB.findIndex(node => node.data === toData);
        if (nodeA === null) {
            // A不在树中
            nodeA = new Node(data);
            parentB.children = Array.concat(childrenB.slice(0, indexB), nodeA, childrenB.slice(indexB));
            nodeA.parent = parentB;
        } else {
            parentA = nodeA.parent;
            childrenA = parentA.children;
            indexA = childrenA.findIndex(node => node.data === data);
            if (parentA === parentB) {
                indexB = indexA < indexB ? indexB - 1 : indexB;
                temp = childrenB.splice(indexA, 1);
                parentB.children = Array.concat(childrenB.slice(0, indexB), temp, childrenB.slice(indexB));
            } else {
                temp = childrenA.splice(indexA, 1);
                parentB.children = Array.concat(childrenB.slice(0, indexB), temp, childrenB.slice(indexB));
                nodeA.parent = parentB;
            }
            temp = null;
        }
        return nodeA;
    }
    /**
     * 在目标节点toData之后插入节点
     * 假设待插入节点为nodeA，目标节点为nodeB
     * A的父节点parentA，B的父节点parentB
     * parentA的孩子childrenA，parentB的孩子childrenB
     * A在兄弟节点中的索引indexA，B在兄弟节点中的索引indexB
     * 1. 先在树中检索A节点
     * 2. 在树中检索B节点，并获取B节点的父亲节点中的索引indexB
     * 3. 如果A不再树中，
     *         创建节点A,
     *         执行数组合并，更新childrenB，nodeB.parent.children = Array.concat(childrenB.slice(0, indexB + 1), A, childrenB.slice(indexB + 1))
     *         设置节点nodeA.parent = parentB
     * 4. 如果nodeA在树中，获取nodeA的父节点parentA和A的索引indexA
     * 5. 如果parentA === parentB,证明nodeA与nodeB在同级
     *         判断indexA < indexB
     *         如果indexA < indexB, indexB = indexB - 1;
     *         执行let temp = childrenB.splice(indexA, 1)
     *         执行nodeB.parent.children = Array.concat(childrenB.slice(0, indexB + 1), temp, childrenB.slice(indexB + 1))
     * 6. 如果parentA !== parentB,证明节点A与节点B不再同级
     *         执行let temp = childrenA.splice(indexA, 1);
     *         执行nodeB.parent.children = Array.concat(childrenB.slice(0, indexB + 1), temp, childrenB.slice(indexB + 1))
     *         执行更新nodeA.parent, nodeA.parent = B.parent
     * @param {ComponentInstanceMeta} data
     * @param {ComponentInstanceMeta} toId
     * @param {Function} traversal
     * @returns {Node} nodeA
     */
    after(data, toData, traversal) {
        let checkDataFn = function(node) {
            return node.data === data;
        };
        let checkToDataFn = function(node) {
            return node.data === toData;
        };
        if (!traversal) {
            traversal = this.traverseDF;
        }
        let nodeA = this.getNode(checkDataFn, traversal);
        let nodeB = this.getNode(checkToDataFn, traversal);
        let parentA = null;
        let parentB = null;
        let childrenA = null;
        let childrenB = null;
        let indexA = -1;
        let indexB = -1;
        let temp = null;
        if (nodeB === null) {
            throw new Error('Target Node is not in the tree');
        }
        parentB = nodeB.parent;
        childrenB = parentB.children;
        indexB = childrenB.findIndex(node => node.data === toData);
        if (nodeA === null) {
            // A不在树中
            nodeA = new Node(data);
            parentB.children = Array.concat(childrenB.slice(0, indexB + 1), nodeA, childrenB.slice(indexB + 1));
            nodeA.parent = parentB;
        } else {
            parentA = nodeA.parent;
            childrenA = parentA.children;
            indexA = childrenA.findIndex(node => node.data === data);
            if (parentA === parentB) {
                indexB = indexA < indexB ? indexB - 1 : indexB;
                temp = childrenB.splice(indexA, 1);
                parentB.children = Array.concat(childrenB.slice(0, indexB + 1), temp, childrenB.slice(indexB + 1));
            } else {
                temp = childrenA.splice(indexA, 1);
                parentB.children = Array.concat(childrenB.slice(0, indexB + 1), temp, childrenB.slice(indexB + 1));
                nodeA.parent = parentB;
            }
            temp = null;
        }
        return nodeA;
    }
    /**
     * 向树中目标节点新增一个节点
     * 假设待插入节点为nodeA，目标节点为nodeB
     * A的父节点parentA
     * parentA的孩子节点childrenA
     * A在兄弟节点中的索引indexA
     * 1. 现在树中检索A节点
     * 2. 在树中检索B节点
     * 3. 如果A不再树中
     *         直接执行this.add(data, toData, traversal)为树添加新节点
     * 4. 如果nodeA在树中，获取nodeA的父节点parentA和A的索引indexA
     * 5. 执行let temp = childrenA.splice(indexA, 1);直接把nodeA从它的父节点中删除
     *         执行nodeB.children.push(nodeA);将nodeA插入nodeB的孩子中
     *         更新nodeA.parent,执行nodeA.parent = nodeB;将nodeA的parent指向nodeB
     *
     * @param {ComponentInstanceMeta} data
     * @param {ComponentInstanceMeta} toData
     * @param {Function} traversal
     * @returns {Node} nodeA
     */
    append(data, toData, traversal) {
        let checkDataFn = function(node) {
            return node.data === data;
        };
        let checkToDataFn = function(node) {
            return node.data === toData;
        };
        if (!traversal) {
            traversal = this.traverseDF;
        }
        let nodeA = this.getNode(checkDataFn, traversal);
        let nodeB = this.getNode(checkToDataFn, traversal);
        let parentA = null;
        let parentAChildren = null;
        let indexA = -1;
        let temp = null;
        if (nodeB === null) {
            throw new Error('Target Node is not in the tree');
        }
        if (nodeA === null) {
            // A不再树中
            // nodeA = new Node(data);
            nodeA = this.add(data, toData, this.traverseDF);
        } else {
            parentA = nodeA.parent;
            parentAChildren = parentA.children;
            indexA = parentAChildren.findIndex(node => node.data === data);
            temp = parentAChildren.splice(indexA, 1);
            nodeB.children.push(nodeA);
            nodeA.parent = nodeB;
            temp = null;
        }
        return nodeA;
    }

    /**
     * 序列化树的数据(默认广度优先遍历)
     * @param {TreeModel} tree
     * @param {Boolean} isDF         是否深度遍历
     * @returns    {Object} 树的节点遍历后的一维数组
     *         {
     *                 isDF: true|false,
     *                 nodes: [nodeInstance, nodeInstance, ....]
     *         }
     */
    static serialize(tree, isDF) {
        let ret = {
            isDF: isDF === true ? true : false,
            nodes: []
        };
        if (tree instanceof TreeModel !== true) {
            console.error(new Error('it it not instanceof TreeModel'));
            return ret;
        }
        let traversal = isDF === true ? tree.traverseDF : tree.traverseBF;
        let callback = function(node) {
            ret.nodes.push(node);
        };
        traversal.call(tree, callback);
        return ret;
    }
    /**
     * 创建树
     * @param {Array} arr
     * @param {Function} getMainKeyFn 获取主键字段方法，返回标记节点主键字段名
     * @param {Function} getParentKeyFn 获取父节点主键方法，返回标记父节点字段名
     * @returns {TreeModel | NULL}
     */
    static createTree(arr, getMainKeyFn, getParentKeyFn) {
        if (!arr || arr.length === 0) {
            console.error(new Error('Cannot create tree'));
            return null;
        }
        if (!getMainKeyFn || !getParentKeyFn) {
            console.error(new Error('getMainKeyFn, getParentKeyFn cannot be undefined'));
        }
        let map = new Map();
        let tree = null;
        arr.forEach((item) => {
            map.set(getMainKeyFn(item), item);
            if (!getParentKeyFn(item)) {
                tree = new TreeModel(item);
            } else {
                let parentNode = map.get(getParentKeyFn(item));
                tree.add(item, parentNode, tree.traverseBF);
            }
        });
        return tree;
    }
}
